import { render, staticRenderFns } from "./CustomerBookRow.vue?vue&type=template&id=f2588798"
import script from "./CustomerBookRow.vue?vue&type=script&lang=js"
export * from "./CustomerBookRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports